import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/plugins/store'
import Login from '@/components/Login'
import CreativeReportList from '@/components/CreativeReportList'
import CpmCreativeReportList from '@/components/CpmCreativeReportList'
import AgencyList from '@/components/AgencyList'
import AdvertiserList from '@/components/AdvertiserList'
import CampaignList from '@/components/CampaignList'
import CampaignPeriodList from '@/components/CampaignPeriodList'
import CpcReport from '@/components/CpcReport'
import CpaReport from '@/components/CpaReport'
import CampaignReport from '@/components/CampaignReport'
import Digestive from '@/components/Digestive'
import SubmissionConfirmationCampaignList from '@/components/SubmissionConfirmationCampaignList'
import SubmissionConfirmationCreativeSetting from '@/components/SubmissionConfirmationCreativeSetting'
import RePassword from '@/components/RePassword'
import Forgot from '@/components/Forgot'
import Error from '@/components/Error'
import LoginRouteBranch from '@/components/LoginRouteBranch'

function requireAuth(to, from, next) {
  store
    .dispatch('auth/getSession')
    .then(attributes => {
      next()
    })
    .catch(attributes => {
      clearStorage()
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    })
}

function logout(to, from, next) {
  store.dispatch('auth/logout')
    .then(() => {
      clearStorage();
      next({ path: '/login' });
    })
    .catch((error) => {
      console.error("Logout process failed:", error);
      clearStorage();
      next({ path: '/login' });
    });
}
function clearStorage() {
  store.dispatch('auth/reset')
  store.dispatch('digestive/reset')
  store.dispatch('report/reset')
  store.dispatch('deliveryMonth/reset')
}

export default createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/loginRouteBranch'
    },
    {
      path: '/agencyList',
      name: 'AgencyList',
      component: AgencyList,
      beforeEnter: requireAuth
    },
    {
      path: '/advertiserList/:agencyId',
      name: 'AdvertiserList',
      component: AdvertiserList,
      props: true,
      beforeEnter: requireAuth
    },
    // ↓楽天用のため使われていない
    {
      path: '/campaignList/:agencyId/:advertiserId',
      name: 'CampaignList',
      component: CampaignList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/campaignPeriodList/:agencyId/:advertiserId',
      name: 'CampaignPeriodList',
      component: CampaignPeriodList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/cpcReport/:agencyId/:advertiserId/:campaignPeriodId',
      name: 'CpcReport',
      component: CpcReport,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/cpaReport/:agencyId/:advertiserId/:campaignPeriodId',
      name: 'CpaReport',
      component: CpaReport,
      props: true,
      beforeEnter: requireAuth
    },
    // ↓楽天用のため使われていない
    {
      path: '/campaignReport/:agencyId/:privateCode/:advertiserId/:campaignId',
      name: 'CampaignReport',
      component: CampaignReport,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/creativeReportList/:agencyId/:advertiserId',
      name: 'CreativeReportList',
      component: CreativeReportList,
      props: true,
      beforeEnter: requireAuth
    },
    // ↓楽天用のため使われていない
    {
      path: '/cpmCreativeReportList/:agencyId/:advertiserId',
      name: 'CpmCreativeReportList',
      component: CpmCreativeReportList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/digestive/:agencyId/:advertiserId',
      name: 'Digestive',
      component: Digestive,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/campaignLanding/counts/:agencyId/:advertiserId',
      name: 'SubmissionConfirmationCampaignList',
      component: SubmissionConfirmationCampaignList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/campaignLanding/creativeList/:agencyId/:advertiserId',
      name: 'SubmissionConfirmationCreativeSetting',
      component: SubmissionConfirmationCreativeSetting,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/loginRouteBranch',
      name: 'LoginRouteBranch',
      component: LoginRouteBranch
    },
    {
      path: '/rePassword',
      name: 'RePassword',
      component: RePassword
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot
    },
    { path: '/logout', name: 'logout', beforeEnter: logout },
    { path: '/error', component: Error },
    { path: '/:pathMatch(.*)*', redirect: '/error' }
  ]
})
